import React, { Component } from "react"
import styled from 'styled-components';

export const StyledLabelSpan = styled.span`
  display: block;
  padding-bottom: 0.2rem;
`;

interface SpanWrapperProps extends React.HTMLAttributes<HTMLSpanElement> {
  [key: string]: any
}

class PraxFormLabelSpan extends Component<SpanWrapperProps> {

  render(): React.ReactNode {
    const {children, ...rest} = this.props;
    return (
        <StyledLabelSpan {...rest}>
          {children}
        </StyledLabelSpan>
    )
  }
}

export default PraxFormLabelSpan;
